import React from 'react';
import './ProjectsSearchPanel.scss';
import {ReactComponent as UploadSvg} from '../../../../assets/icons/upload2.svg';
import {ReactComponent as TrashSvg} from '../../../../assets/icons/delete-24.svg';
import InputMUISearch from '../../../../shared/InputMUISearch';
import CheckboxMUI from '../../../../shared/CheckboxMUI';
import {useTranslation} from 'react-i18next';
import {IconButtonMUI} from '../../../../shared';
import {useSelector} from "react-redux";

const ProjectsSearchPanel = ({
  downloadAllHandler,
  searchVal,
  handleSearch,
  handleClear,
  handleChange,
  handleCheckAll,
  isCheckAll,
  checkedItems,
  removeHandlerAll,
  permissionTrash,
  permissionDownload
}) => {
  const {t} = useTranslation();
  const profileMe = useSelector((state) => state.profile.profileMe);

  return (
    <>
      <div className={'projects-search'}>
        {permissionDownload || permissionTrash  ? <div className='projects-search__check'>
          <CheckboxMUI label={t('ProjectsCheckboxPanel.all')} onChange={handleCheckAll} checked={isCheckAll} />
        </div> : null}
        <div className='projects-search__input'>
          <InputMUISearch
            className='search-box__input'
            fullWidth
            value={searchVal}
            onSearch={() => {}}
            onClear={handleClear}
            onChange={handleChange}
            placeholder={t('ProjectsSearchPanel.Search')}
          />
        </div>
        {permissionDownload || permissionTrash ?
            <div className={`projects-search__icons${checkedItems.length ? ' checked' : ''}`}>
              {permissionDownload &&  (
                  <div className='projects-search__download' onClick={downloadAllHandler}>
                    <IconButtonMUI color={'inherit'} title={t('ProjectsDocuments.download')}>
                      <UploadSvg />
                    </IconButtonMUI>
                  </div>
              )}
              {permissionTrash && (
                  <div className='projects-search__delete' onClick={removeHandlerAll}>
                    <IconButtonMUI color={'inherit'} title={t('ProjectsDocuments.delete')}>
                      <TrashSvg />
                    </IconButtonMUI>
                  </div>
              )}
            </div>
        : null
        }
      </div>
      <div className='projects-search-mob'>
        <InputMUISearch
          className='search-box__input'
          fullWidth
          value={searchVal}
          onSearch={() => {}}
          onClear={handleClear}
          onChange={handleChange}
          placeholder={t('ProjectsSearchPanel.Search')}
        />
      </div>
    </>
  );
};

export default ProjectsSearchPanel;
